export default {
  aboutPage: {
    seoTitle: 'عن Geofleet — برنامج لإدارة التوصيل مدعوم بالذكاء الاصطناعي',
    seoDescription:
      'تطوّر Geofleet برنامجاً لإدارة عمليات التوصيل مع Copilot مدعوم بالذكاء الاصطناعي، يستخدمه أكثر من 100 عميل في أكثر من 20 دولة. حاصل على شهادتي SOC 2 وISO 27001، مع أسعار معلنة تبدأ من 100 دولار شهرياً لـ10 سائقين.',
    badge: 'عن Geofleet',
    title: 'نبني مركز القيادة',
    titleHighlight: 'لفرق التوصيل',
    lead:
      'Geofleet برنامج لإدارة عمليات التوصيل للفرق التي تدير أساطيلها الخاصة. يخطط المرسِلون كل محطة ويتابعونها من مركز قيادة واحد، ويعمل السائقون من تطبيق واحد، ويتابع العملاء طلباتهم عبر رابط تتبع مباشر. ويتولى Copilot المدعوم بالذكاء الاصطناعي المهام الروتينية ضمن الصلاحيات التي تحددها.',
    stats: [
      { value: '100+', label: 'عملاء' },
      { value: '20+', label: 'دول' },
      { value: '50+', label: 'تكاملات' },
      { value: '99.99%', label: 'وقت التشغيل' },
    ],
    heroImageAlt: 'مركز قيادة Geofleet مع خريطة توصيل مباشرة ومؤشرات أداء وطلبات اليوم',

    missionKicker: 'لماذا نحن هنا',
    missionTitle: 'معظم عمليات التوصيل ما زالت تُدار عبر المحادثات وجداول البيانات',
    missionBody: [
      'في معظم عمليات التوصيل، تكون الخطة في جدول بيانات، ويتم الإرسال عبر مجموعات المحادثة، ويتصل العملاء للسؤال عن مكان طلباتهم. وكل تأخير لسائق يتحول إلى سلسلة من المكالمات الهاتفية.',
      'أسسنا Geofleet لنجمع هذا العمل في مكان واحد. تصل الطلبات، وتُخطَّط المسارات، ويُرسَل السائقون، ويبقى العملاء على اطلاع، وينتهي كل توصيل بإثبات. وعندما يحدث خلل، يُظهره مركز القيادة أولاً ويقترح Copilot الحل.',
    ],
    missionQuote: 'هدفنا: أن يحصل كل فريق توصيل على الأدوات التي تملكها شركات الشحن الكبرى، دون دورة مبيعات مؤسسية طويلة.',

    principlesKicker: 'طريقة عملنا',
    principlesTitle: 'ما نؤمن به',
    principles: [
      {
        title: 'السعر معلن على الصفحة',
        body: 'أسعار معلنة تبدأ من 100 دولار شهرياً لـ10 سائقين. يجب أن تعرف التكلفة قبل أن تتحدث مع أي أحد.',
      },
      {
        title: 'ذكاء اصطناعي ضمن ضوابط',
        body: 'يعمل Copilot ووكلاء الذكاء الاصطناعي لدينا ضمن دور كل مستخدم فقط. هم يقترحون، والأشخاص يؤكدون، وكل تغيير يُسجَّل.',
      },
      {
        title: 'مبني على البيانات المباشرة',
        body: 'كل إجابة واقتراح يستند إلى ما يحدث على الطريق الآن، لا إلى نص عام مولَّد بالذكاء الاصطناعي.',
      },
      {
        title: 'الأمان ليس خياراً',
        body: 'Geofleet حاصل على شهادتي SOC 2 وISO 27001، مع تشفير البيانات أثناء التخزين والنقل، وتحكم في الوصول حسب الدور في كل أجزاء المنصة.',
      },
    ],

    productKicker: 'ما نبنيه',
    productTitle: 'منصة واحدة، من الطلب إلى إثبات التسليم',
    products: [
      { title: 'مركز القيادة', body: 'خريطة مباشرة واستثناءات مرتبة حسب الأولوية وكل الطلبات في عرض واحد.', href: '/how-it-works' },
      { title: 'Copilot ووكلاء الذكاء الاصطناعي', body: 'اسأل بلغة بسيطة، وأتمت الإرسال، وعالج الاستثناءات.', href: '/features/ai-agents' },
      { title: 'مخطط المسارات', body: 'مسارات محسّنة تراعي النوافذ الزمنية والسعة وحركة المرور.', href: '/features/route-planner' },
      { title: 'تطبيق السائق', body: 'الملاحة وإثبات التسليم وتسجيل الحضور، حتى دون اتصال.', href: '/features/driver-app' },
      { title: 'تتبع بعلامتك التجارية', body: 'رابط تتبع مباشر يفتحه العملاء في أي متصفح.', href: '/features/branded-tracking' },
      { title: 'التقارير والتحليلات', body: 'معدل الالتزام بالموعد وتكلفة كل توصيلة وبطاقات أداء السائقين.', href: '/features/reports-analytics' },
    ],

    industriesKicker: 'من نخدم',
    industriesTitle: 'فرق توصل كل يوم',
    industriesBody:
      'تستخدم المطاعم والصيدليات وشركات التوصيل السريع ومحلات البقالة ومتاجر التجزئة والموزعون وفرق الخدمة الميدانية Geofleet في أكثر من 20 دولة، من أساطيل من 10 سائقين إلى عمليات متعددة المراكز.',
    industriesCta: 'عرض كل القطاعات',

    trustKicker: 'الثقة والأمان',
    trustTitle: 'منصة يمكنك الاعتماد عليها',
    trustItems: [
      { title: 'SOC 2', body: 'ضوابط أمنية خاضعة لتدقيق مستقل.' },
      { title: 'ISO 27001', body: 'إدارة معتمدة لأمن المعلومات.' },
      { title: 'وقت تشغيل 99.99%', body: 'منصة يمكن لفريق الإرسال الاعتماد عليها طوال اليوم.' },
      { title: 'التشفير والتحكم في الوصول', body: 'بيانات مشفرة أثناء التخزين والنقل، مع صلاحيات حسب الدور وسجلات تدقيق.' },
    ],
    trustCta: 'اطلب وثائق الأمان الخاصة بنا',

    connectKicker: 'اعمل معنا',
    connectTitle: 'تواصل معنا',
    connectCards: [
      { title: 'جرّب Geofleet', body: 'ابدأ مع Geofleet Lite بطلباتك الخاصة، من 100 دولار شهرياً لـ10 سائقين.', cta: 'ابدأ الآن' },
      { title: 'تحدث إلى فريقنا', body: 'احجز عرضاً توضيحياً وسنستعرض معك سير عمل التوصيل لديك.', cta: 'احجز عرضاً توضيحياً' },
      { title: 'كن شريكاً', body: 'أعد بيع Geofleet أو ادمجه في أنظمتك، مع بوابة شركاء بخدمة ذاتية.', cta: 'برنامج الشركاء' },
    ],
    contactLine: 'للاستفسارات العامة:',
  },
};
